.root {
  margin: auto auto 0;
}

.hr {
  margin: 2.5rem 1rem 0;
  border: solid hsl(var(--border));
  border-width: 0;
  border-top-width: 1px;
}

.content {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.5rem 1rem;
  color: hsl(var(--muted-foreground));
  white-space: nowrap;
  text-align: center;
}

.logoWrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.logo {
  width: 1.25rem;
  height: 1.25rem;
}

.address {
  display: inline;
  font-style: normal;
}

.dot {
  color: hsl(var(--primary));
}
